import { technicalHelpNumber } from 'modules/constants/phoneNumbers';
import { AppName, CompanyName, getAppName } from 'modules/utils/ConfigUtils';

export const ProfileUpdateMessages = {
  VALIDATE_ADDRESS: {
    title: 'Address verification failed',
    message: `Confirm information and try again or contact any ${CompanyName} clinic for assistance.`
  },

  VALIDATE_EMAIL: {
    title: 'Email verification failed',
    message: `Confirm information and try again or contact any ${CompanyName} clinic for assistance.`
  },

  VALIDATE_PHONE: {
    title: 'SMS verification failed',
    message: `Confirm information and try again or contact any ${CompanyName} clinic for assistance.`
  },

  UPDATE_ADDRESS: {
    title: 'Failed to update address',
    message: `If the problem persists please contact any ${CompanyName} clinic for assistance.`
  },

  UPDATE_EMAIL: {
    title: 'Failed to update email',
    message: `If the problem persists please contact any ${CompanyName} clinic for assistance.`
  },

  UPDATE_PHONE: {
    title: 'Failed to update phone',
    message: `If the problem persists please contact any ${CompanyName} clinic for assistance.`
  }
} as const;

export const DELETE_ACCOUNT_TEXT = {
  TITLE_1: 'Delete your',
  TITLE_2: `${getAppName(AppName.base, '', AppName.suffix3)}`,
  DESCRIPTION: `To cancel your ${getAppName(AppName.base)} and Select Health ${getAppName(
    AppName.suffix4
  )} account you will need to request account deletion or call our customer service line. The benefits of keeping an account include:`,
  BENEFIT_1: '• Access medical records anytime',
  BENEFIT_2: '• Manage your billing',
  BENEFIT_3: '• Schedule with a doctor',
  BENEFIT_4: '• Message with caregivers',
  DELETE_BTN: 'Delete Account Request',
  CALL_BTN: `Call Online Service ${technicalHelpNumber}`,
  NOTE:
    'Deleting your account does not delete your medical records. Laws requires us to store your medical records, which you can access by contacting us.'
};
